export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING';

export const setGlobalLoading = globalLoading => ({
  type: SET_GLOBAL_LOADING,
  globalLoading
});
